import React from 'react';

export default function Block5Results() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-16 bg-paper border-b border-line" id="dos-motores">
      <div className="max-w-[1000px] mx-auto flex flex-col items-start w-full">
        <div className="mb-14 md:mb-16 max-w-2xl px-2">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-4">
            Arquitectura
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink leading-[1.2] tracking-tight">
            Dos motores. Una misma operación.
          </h2>
        </div>
        <div className="w-full flex flex-col gap-12 relative px-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full max-w-4xl">
            <div className="flex flex-col text-left">
              <div className="text-[14px] font-semibold text-brand mb-2">Motor preventivo</div>
              <div className="text-[20px] font-bold text-ink mb-4 leading-[1.2]">Episodios que deben resolverse</div>
              <div className="text-[14px] text-ink-soft leading-relaxed">
                Cada hallazgo de riesgo inicia un episodio operacional finito. Termina cuando el paciente recibe la evaluación y se convierte en un evento verificado en la red.
              </div>
            </div>
            <div className="flex flex-col text-left">
              <div className="text-[14px] font-semibold text-brand mb-2">Motor de continuidad</div>
              <div className="text-[20px] font-bold text-ink mb-4 leading-[1.2]">Hitos que deben cumplirse y continuar</div>
              <div className="text-[14px] text-ink-soft leading-relaxed">
                El paciente crónico no recibe el "alta" tras una visita. Sus hitos forman trayectorias que deben mantenerse en el tiempo, asegurando su permanencia en el flujo clínico.
              </div>
            </div>
          </div>
          <div className="w-full max-w-4xl pt-12 border-t border-line flex flex-col items-start">
            <div className="text-[18px] font-bold text-ink mb-5">
              Núcleo operacional compartido
            </div>
            <div className="flex flex-wrap items-center gap-6 text-[24px] font-medium text-ink-soft/70 mx-auto">
              <span>Evidencia</span>
              <span className="text-ink-soft/30">→</span>
              <span>Prioridad</span>
              <span className="text-ink-soft/30">→</span>
              <span className="text-brand">Próxima acción</span>
              <span className="text-ink-soft/30">→</span>
              <span>Verificación</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
